import { render, staticRenderFns } from "./SPRSimpleCheckboxList2.vue?vue&type=template&id=345bf8f8"
import script from "./SPRSimpleCheckboxList2.vue?vue&type=script&lang=ts"
export * from "./SPRSimpleCheckboxList2.vue?vue&type=script&lang=ts"
import style0 from "./SPRSimpleCheckboxList2.vue?vue&type=style&index=0&id=345bf8f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports